import Axios from "axios";
import { userService } from "../../_services";

export const users = {
  namespaced: true,
  state: {
    all: {},
    users: null,
    single: [],
  },
  actions: {
    getAll({ commit }) {
      commit("getAllRequest");

      userService.getAll().then(
        (users) => commit("getAllSuccess", users),
        (error) => commit("getAllFailure", error)
      );
    },
    async deleteUser(context, payload){
      let userToken = JSON.parse(localStorage.getItem("user"));

      let options = {
        headers: { Authorization: `Bearer ${userToken.jwt}` },
      };
      if(context.rootState.auth.loggedIn.admin){
        const response = await Axios.delete(`https://api.rightcloud.pl/renty-emps/${payload}`, options);
      }
    },
    async addEmployee(context, payload) {
      let userToken = JSON.parse(localStorage.getItem("user"));

      let options = {
        headers: { Authorization: `Bearer ${userToken.jwt}` },
      };
      const response = await Axios.post(
        "https://api.rightcloud.pl/renty-emps",
        payload,
        options
      )
      const responseData = await response
      if(responseData.status !== 200){
        const error = new Error(responseData.message || 'Failed to add new employee. Please try again later.');
        throw error;
      } 
    },
    async fetchUsers(context) {
      let userToken = JSON.parse(localStorage.getItem("user"));
      let options = {
        headers: { Authorization: `Bearer ${userToken.jwt}` },
      };

      const response = await Axios.get(
        "https://api.rightcloud.pl/renty-emps",
        options
      );
      const responseData = await response
      context.commit("fetchUsers", responseData.data);
    },
    async fetchSingle(context, payload) {
      let userToken = JSON.parse(localStorage.getItem("user"));
      let options = {
        headers: { Authorization: `Bearer ${userToken.jwt}` },
      };
      const response = await Axios.get(
        `https://api.rightcloud.pl/renty-emps/${payload}`,
        options
      );
      const responseData = await response;
      context.commit("setSingle", responseData.data);
    },
    async updateEmployee(context, {data, param}) {
      let userToken = JSON.parse(localStorage.getItem("user"));
      let options = {
        headers: { Authorization: `Bearer ${userToken.jwt}` },
      };
      const response = await Axios.put(
        `https://api.rightcloud.pl/renty-emps/${param}`,
        data,
        options
      );
      const responseData = await response
      context.commit("updateEmployee", responseData.data);
    },
  },
  mutations: {
    fetchUsers(state, payload) {

      state.users = payload;
    },
    setSingle(state, payload) {
      state.single = payload;
    },
    updateEmployee(state, payload) {

      state.single = payload;
    },
    getAllRequest(state) {
      state.all = { loading: true };
    },
    getAllSuccess(state, users) {
      state.all = { items: users };
    },
    getAllFailure(state, error) {
      state.all = { error };
    },
  },
  getters: {
    fetchUsers(state) {
      return state.users;
    },
    getSingle(state) {
      return state.single ;
    },
    getActiveUsers(state){
      let activeUser = state.users.filter(user => user.active && user.drivingSys === '3Z')

      return activeUser.sort((a,b) => a.lastName !== b.lastName ? a.lastName < b.lastName ? -1 : 1 : 0)
    }
  },
};
